import React from "react";
import RainWater from "../../assets/icons/Rain Water Harvesting-01.png";
import EfficientEnvelop from "../../assets/icons/Efficient Envelope-01.png";
import Ventilation from "../../assets/icons/MAXIMUM VENTILATION, AND CROSS BREEZE-01.png";
import Amenities from "../../assets/icons/Basic Amenities-01.png";
import VOC from "../../assets/icons/LOW VOC PAINTS & ADHESIVES-01.png";
import Renewable from "../../assets/icons/RENEWABLE ENERGY-01.png";
import WaterConservation from "../../assets/icons/WATER CONSERVATION-01.png";
import WaterManagement from "../../assets/icons/WATER MANAGEMENT-01.png";
import SolidWaste from "../../assets/icons/SOLID WASTE MANAGEMENT-01.png";

const cardData = [
  {
    icon: RainWater,
    title: "Rain Water Harvesting",
    desc: "The project captures rainwater to recharge groundwater and reduce municipal water use.",
  },
  {
    icon: EfficientEnvelop,
    title: "Efficient Envelope Design",
    desc: "Optimized building design helps reduce energy consumption.",
  },
  {
    icon: Ventilation,
    title: "Optimized Ventilation",
    desc: "Thoughtful ventilation supports airflow and cross-breeze for better indoor comfort.",
  },
  {
    icon: Amenities,
    title: "Basic Amenities",
    desc: "The project site is planned to reduce vehicle impact while providing essential amenities.",
  },
  {
    icon: VOC,
    title: "Low-VOC Materials",
    desc: "Paints and adhesives are used with a focus on healthier indoor air.",
  },
  {
    icon: Renewable,
    title: "Renewable energy",
    desc: "Renewable energy sources are utilized to support more sustainable project operations.",
  },
  {
    icon: WaterConservation,
    title: "Water Conservation",
    desc: "Water-conservation strategies are implemented to promote efficient and sustainable water use.",
  },
  {
    icon: WaterManagement,
    title: "Water Management",
    desc: "Low-flow fixtures and native-plant landscaping are designed to reduce on-site water use by 25%.",
  },
  {
    icon: SolidWaste,
    title: "Solid Waste management",
    desc: "Centralized waste collection supports flat-level dry and wet waste segregation.",
  },
];

export default function CardGrid() {
  return (
    <div className="grid xl:grid-cols-3 grid-cols-2 gap-6 my-7 max-w-screen-xl mx-auto">
      {cardData.map((card, index) => (
        <div
          key={index}
          className="rounded-[16px] p-2 shadow-[inset_0_0_2px_1px_rgba(0,0,0,0.5)]"
        >
          <div className="bg-[#fdf6f6] rounded-[14px] p-5 h-[260px] flex flex-col justify-between">
            <div>
              <div className="bg-[#fff] w-16 h-16 flex justify-center items-center rounded-xl mb-4">
                <img src={card.icon} alt="" className="w-auto h-auto" />
              </div>
              <p className="text-[24px] font-inter mb-2 text-[#5e3920] text-left">
                {card.title}
              </p>
              <p className="text-[#000000d9] text-[15px] leading-relaxed font-inter text-left w-[90%]">
                {card.desc}
              </p>
            </div>
            <div className="flex items-center gap-2 mt-3">
              <div className="border border-[#0000001a] w-[80%]"></div>
              <span className="w-4 h-4 rounded-full bg-[#0000001a]"></span>
              <span className="w-4 h-4 rounded-full bg-[#0000001a]"></span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
